export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img
    src="/images/logo-mark.png"
    alt="BrandZenith"
    className={`${className} object-contain`}
  />
);

export const Logo = ({ small = false }) => (
  <img
    src="/images/brandzenith-logo.png"
    alt="BrandZenith — Make Your Next Move."
    className={`${small ? "h-8" : "h-12"} w-auto select-none`}
  />
);
